import { UilInstagram, UilWhatsapp } from "@iconscout/react-unicons";
import React, { useState } from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { nacionalPhoneMask } from "../../../services/Functions";
import Configuracoes from "../../../types/Configuracoes";
import "./styles";
import { LogoContainer, MockupCatalogoContainer } from "./styles";

interface MockupCatalogoProps {
  configuracoes: Configuracoes;
  produtos?: boolean;
  mostrarFooter?: boolean;
}

const MockupCatalogo: React.FC<MockupCatalogoProps> = ({
  configuracoes,
  produtos = false,
  mostrarFooter = true,
}) => {
  const { theme } = useTheme();

  const [mostrarVariacoes, setMostrarVariacoes] = useState<boolean>(false);
  const toggleMostrarVariacoes = () => {
    setMostrarVariacoes(!mostrarVariacoes);
  };

  const limiteVariacoes = Number.parseInt(
    configuracoes.catalogo.limite_variacoes
  );

  const LogoTipo = () => {
    return (
      <LogoContainer theme={theme}>
        {configuracoes.dados_empresa.informacoes_gerais.logotipo && (
          <img
            src={
              configuracoes.dados_empresa.informacoes_gerais.logotipo["base64"]
                ? configuracoes.dados_empresa.informacoes_gerais.logotipo[
                "base64"
                ]
                : configuracoes.dados_empresa.informacoes_gerais.logotipo
            }
            alt=""
          />
        )}
      </LogoContainer>
    );
  };

  return (
    <MockupCatalogoContainer theme={theme} configuracoes={configuracoes}>
      {!produtos && (
        <>
          <div className="header">
            <div className="logoHeaderContainer">
              <LogoTipo />
            </div>
            <div className="infosEmpresa">
              <div className="nome fonteTexto">
                {configuracoes.dados_empresa.informacoes_gerais.nome}
              </div>
              <div
                className="descricao fonteRotulos"
                dangerouslySetInnerHTML={{
                  __html: configuracoes.dados_empresa.informacoes_gerais.descricao,
                }}
              ></div>
              <div className="social fonteRotulos">
                <div className="rede">
                  <UilWhatsapp style={{ width: "2rem" }}></UilWhatsapp>
                  {configuracoes.dados_empresa.redes_sociais.whatsapp
                    ? nacionalPhoneMask(
                      configuracoes.dados_empresa.redes_sociais.whatsapp
                    )
                    : "(54) 99999-9999"}
                </div>
                <div className="rede">
                  <UilInstagram style={{ width: "2rem" }}></UilInstagram>
                  {configuracoes.dados_empresa.redes_sociais.instagram
                    ? configuracoes.dados_empresa.redes_sociais.instagram
                    : "@instagram"}
                </div>
              </div>
            </div>
          </div>
          <div className="categorias-container">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="categoria"></div>
            ))}
          </div>
          <div className="banner-container">
            <div className="banner"></div>
          </div>
          <div className="filtros">
            {Array.from({ length: 2 }).map((_, index) => (
              <div key={index} className="filtro"></div>
            ))}
          </div>
        </>
      )}
      {produtos && (
        <div className="produtos scrollBonito">
          {Array.from({ length: 4 }).map((_, index) => {
            return (
              <div key={index} className="produto">
                <div className="imagem">
                  <div className="fundoImagem" />
                </div>
                <div className="botaoCompartilhar">
                  {configuracoes.catalogo
                    .mostrar_botao_compartilhamento_produto && (
                      <div className="botao fonteRotulos">
                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21"><title>WhatsApp</title>
                          <path className="cls-1"
                            d="M18,3a10.14,10.14,0,0,0-7.2-3h0A10.19,10.19,0,0,0,.63,10.18a10.07,10.07,0,0,0,1.14,4.67L.05,19.74a.94.94,0,0,0,.23,1A.94.94,0,0,0,.94,21,1.19,1.19,0,0,0,1.26,21l4.89-1.72a10.18,10.18,0,0,0,14.85-9A10.14,10.14,0,0,0,18,3Zm-.87,13.53a8.9,8.9,0,0,1-6.33,2.63,9.05,9.05,0,0,1-4.21-1.05A.94.94,0,0,0,5.86,18L1.41,19.59,3,15.14a.93.93,0,0,0-.06-.75,9.05,9.05,0,0,1-1-4.21,9,9,0,0,1,9-8.95h0a9,9,0,0,1,6.33,15.28Z"></path>
                          <path className="cls-1"
                            d="M14.32,11.37a1.2,1.2,0,0,0-1.7,0l-.51.51a7.42,7.42,0,0,1-3-3l.51-.51a1.2,1.2,0,0,0,0-1.7L8.25,5.3a1.2,1.2,0,0,0-1.7,0L5.44,6.4c-.63.63-.66,1.72-.09,3.06a12.15,12.15,0,0,0,2.58,3.61,12.15,12.15,0,0,0,3.61,2.58,4.43,4.43,0,0,0,1.72.4,1.83,1.83,0,0,0,1.34-.49l1.1-1.11h0a1.18,1.18,0,0,0,0-1.7Zm-.59,3.32c-.18.18-.74.24-1.71-.18A11,11,0,0,1,8.8,12.2,11,11,0,0,1,6.49,9c-.42-1-.36-1.53-.18-1.71L7.4,6.19,8.74,7.53l-.65.64a.93.93,0,0,0-.17,1.09,8.61,8.61,0,0,0,3.82,3.82.93.93,0,0,0,1.09-.17l.64-.65,1.34,1.34Z"></path>
                        </svg>
                        Compartilhar
                      </div>
                    )}
                </div>
                <div className="variacoes">
                  {Array.from({
                    length: mostrarVariacoes
                      ? 11
                      : Math.min(limiteVariacoes, 11),
                  }).map((_, index) => {
                    return (
                      <>
                        <div key={index} className="variacao">
                          <div className="fundoVariacao">
                            {Number.parseInt(
                              configuracoes.catalogo.quantidade_colunas_padrao
                                .mobile
                            ) === 1 && (
                                <>
                                  <div className="variacaoEstoque">
                                    <div className="nomeVariacao">
                                      {`Variação ${index + 1}`}
                                    </div>
                                    {configuracoes.catalogo.mostrar_estoque && (
                                      <div className="estoque">
                                        {`Estoque: ${Math.floor(
                                          Math.random() * 11
                                        )}`}
                                      </div>
                                    )}
                                  </div>
                                  <div>R$ 0,00</div>
                                  <div>0</div>
                                </>
                              )}
                          </div>
                          <div className="bolinha">
                            <div className="fundoBolinha"></div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {limiteVariacoes < 11 && (
                    <div className="expandir fonteRotulos" onClick={toggleMostrarVariacoes}>
                      {mostrarVariacoes
                        ? "Clique para reduzir"
                        : "Clique para expandir"}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {!produtos && mostrarFooter && (
        <div className="footer">
          <div className="footer-container">
            <div className="logoFotterContainer">
              <LogoTipo />
            </div>
            <div className="infos">
              <div className="nome fonteTexto">
                {configuracoes.dados_empresa.informacoes_gerais.nome}
              </div>
              <div
                className="descricao fonteRotulos"
                dangerouslySetInnerHTML={{
                  __html:
                    configuracoes.dados_empresa.informacoes_gerais.descricao,
                }}
              ></div>
              <div className="redes fonteRotulos">
                <div className="rede">
                  <UilWhatsapp style={{ width: "2rem" }}></UilWhatsapp>
                  {configuracoes.dados_empresa.redes_sociais.whatsapp
                    ? nacionalPhoneMask(
                      configuracoes.dados_empresa.redes_sociais.whatsapp
                    )
                    : "(54) 99999-9999"}
                </div>
                <div className="rede">
                  <UilInstagram style={{ width: "2rem" }}></UilInstagram>
                  {configuracoes.dados_empresa.redes_sociais.instagram
                    ? configuracoes.dados_empresa.redes_sociais.instagram
                    : "@instagram"}
                </div>
              </div>
            </div>
          </div>
          {!configuracoes.dados_empresa.endereco.ocultar_endereco_catalogo && (
            <div
              className="endereco fonteRotulos"
              style={{ color: configuracoes.catalogo.cor_secundaria }}
            >
              <span>
                {configuracoes.dados_empresa.endereco.endereco
                  ? configuracoes.dados_empresa.endereco.endereco
                  : "Endereço completo"}
                ,
              </span>
              <span>
                {configuracoes.dados_empresa.endereco.numero
                  ? " " + configuracoes.dados_empresa.endereco.numero
                  : " número"}{" "}
                |
              </span>
              <span>
                {configuracoes.dados_empresa.endereco.complemento
                  ? " " + configuracoes.dados_empresa.endereco.complemento
                  : " complemento"}{" "}
                |<br></br>
              </span>
              <span>
                {configuracoes.dados_empresa.endereco.bairro
                  ? " " + configuracoes.dados_empresa.endereco.bairro
                  : " bairro"}{" "}
                |
              </span>
              <span>
                {configuracoes.dados_empresa.endereco.cep
                  ? " " + configuracoes.dados_empresa.endereco.cep
                  : " 00000-000 "}{" "}
                |
              </span>
              <span>
                {configuracoes.dados_empresa.endereco.cidade
                  ? " " + configuracoes.dados_empresa.endereco.cidade
                  : " Cidade "}{" "}
                -
                {configuracoes.dados_empresa.endereco.estado
                  ? " " + configuracoes.dados_empresa.endereco.estado
                  : " sigla "}{" "}
              </span>
              <span></span>
            </div>
          )}
        </div>
      )}
    </MockupCatalogoContainer>
  );
};

export default MockupCatalogo;
